import React, { Fragment, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

function SideNavigation(props){
    const [state, setState] = useState({isOpen:false});
    const { classes, children } = props;
    const { isOpen } = state;

    const divideSidebar = (children) => {
        const placement = { top: [], bottom: [] };
        if (children) {
            if (children.constructor === Array) {
                children.forEach(child => {
                    if (child.props && child.props.placement === 'bottom') { placement.bottom.push(child); } else { placement.top.push(child); }
                });
            } else {
                if (children.props.placement === 'bottom') { placement.bottom.push(children); } else { placement.top.push(children); }
            }
        }

        return placement;
    }

    const handleDrawerToggle = () => {
        setState(p=>({
            isOpen: !p.isOpen
        }));
    }

    const placement = divideSidebar(children);
    return (
        <div
            className={classnames(classes.drawer, !isOpen && classes.drawerClosed)}
        >
            <div className={classes.content}>
                <div>{placement.top}</div>
                <div>{placement.bottom}</div>
            </div>
        </div>
    );

}

const style = theme => ({
    drawer: {
        backgroundColor: theme.palette.grey.variant1,
        width: '250px',
        paddingBottom: theme.constants.footer,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        overflow: 'visible',
        zIndex: 9
    },
    drawerClosed: {
        width: theme.constants.sidebarNavigationWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    content: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
});

export default withStyles(style)(SideNavigation);